module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAYCAYAAAAh8HdUAAAACXBIWXMAABYlAAAWJQFJUiTwAAAA3ElEQVQ4jY2UYRHCMAyFX1GAgnfDyZCAg80BKAAUgIMhAQfMCbsoQALX3fqjbdI2v3p9e/claTInIjcAV+Qxkzwq99gBeAJYFK0XkV41kfwBuGuikQFcOIjIF0CnfHMi+U7TC2HRHll64UDyZdTWichgkXyMBi2qLTKRnH2ra7SUhJZOZqYWmkaq0pwh+nebAAyKNFqkYqikbeY+irSQPFgkdeZCrRmpRoHRvSIlI7VQNNJUo0Sm7bW1ffIUvwG5qVDLJb1YTQWK/7lEW7uaRGTf0rGUdC5Q8mkH8Af5bEshC26ggQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/img/61.png
// module id = H7Xn
// module chunks = 1